import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from 'antd';

// Own
import { useSendMetricDownloadApp } from './use-send-metrics';
import DownloadAppButton from 'components/download-app/button';

const DownloadApplication: FunctionComponent<Props> = ({ className }) => {
  const { t } = useTranslation('safetag-not-linked');
  const sendMetricDownloadApp = useSendMetricDownloadApp();

  return (
    <div className={className}>
      <div className="download-application__logo-container">
        <img src="/assets/common/logo-vertical.svg" alt="SOSAFE" />
      </div>
      <div className="download-application__text-container">
        <Typography.Paragraph type="secondary">
          {t('subtitle.isNotSosafeUser')}
        </Typography.Paragraph>
        <DownloadAppButton type="primary" shape="round" onClick={sendMetricDownloadApp}>
          {t('downloadApp')}
        </DownloadAppButton>
      </div>
      <div className="download-application__img-container">
        <img
          src="/assets/scan-safetag/items.png"
          srcSet="/assets/scan-safetag/items.png 343w,
                /assets/scan-safetag/items@2x.png 686w"
          alt="Items"
        />
      </div>
    </div>
  );
};

interface Props {
  className?: string;
}

export default DownloadApplication;
